import { useRef, useState } from 'react';
import TabB from '../PageTabs/TabB';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function KRTabs() {
    const [activeTab, setActiveTab] = useState('0');
    const tabRef = useRef<HTMLDivElement | null>(null);
    const { t } = useLang('ecocreditsday');
    const menuRef = useRef<HTMLDivElement | null>(null);
    const tabs = [];
    for (let i = 0; i < 1; i++) {
        tabs.push({ key: `${i}`, name: t(`pageTabs.tab${i + 1}`) });
    }

    // const clickTab = (key: string) => {
    //     if (key !== activeTab) {
    //         setActiveTab(key);
    //         const top = tabRef.current?.offsetTop;
    //         if (top) {
    //             window?.scrollTo({ top: top + 60 });
    //         }
    //     }
    // };

    // const changeTabLine = () => {
    //     const dom: any = tabRef.current;
    //     const { top }: any = dom?.getBoundingClientRect();
    //     const flag = top > 0;
    //
    //     menuRef.current.style.display = flag ? 'inline-flex' : 'flex';
    // };
    //
    // useEffect(() => {
    //     window.addEventListener('scroll', changeTabLine);
    //     return () => {
    //         window.removeEventListener('scroll', changeTabLine);
    //     };
    // }, []);

    return (
        <div className={`${styles.krTabs} tabs-box`}>
            <TabB />
            {/*<div className="kr-tabs" ref={tabRef}>*/}
            {/*    <div className="menu-box">*/}
            {/*        <div className="tabs-menu" ref={menuRef}>*/}
            {/*            {tabs.map((item: Record<string, string>) => (*/}
            {/*                <div key={item.key} className={`tab-item ${item.key === activeTab ? 'active-tab' : ''}`} onClick={() => clickTab(item.key)}>*/}
            {/*                    {item.name}*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="content-box">*/}
            {/*        <div className="tab-content">*/}
            {/*            <TabB />*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}
